import React from "react";
import dynamic from "next/dynamic";
import styles from "../../styles/pages/roiform.module.scss";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
import "react-multi-carousel/lib/styles.css";
import endpoints from "../../utility/endpoints";
import _get from "lodash/get";
import { useRouter } from "next/router";
import axios from "axios";
import { useState, useRef, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RoiModal from "../Pages/roiModal";
import { useMediaQuery } from "react-responsive";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {AreaChart, Area, XAxis, YAxis,CartesianGrid, Tooltip} from 'recharts';
import Loaders from "../Loader";

function index(props) {
  const router = useRouter();
  console.log("Props--Roi-Form", props);

  const {
    submitanidea_cluster_component: clusterFormData,
    submitanidea_leadplatform_component: leadplatFormData,
  } = props.globalData;
  const technologyData = props.technology.field_component[0].component.content.field_request_demo_form_componen;
  console.log("clusterFormData", clusterFormData);
  console.log("leadplatFotechnologyrmData", leadplatFormData);
  console.log('technologyData',technologyData);

  let formInitialState = {
    clusterProcess: "",
    expectedMcoType: "",
    expectedCountry: "",
    leadPlatformProcess: "",
    expectedArea: "",
    expectedSubArea: "",
    opportunityName: "",
    opportunityDescription: "",
    technology: "",
    botId: "",
    manualHours: "",
    annualExecutedProcess: "",
    resourceProcess: "",
    errorRateProcess: "",
    costAvoidance: "",
    impactOfOKR: "",
    developmentCost: "",
    runCostProcess: "",
    resRoiMonthsBreakdown:"",
    resRoiFor1Year:"",
    resRoiFor3Year:"",
    roiMonthsBreakdown:"",
    roiFor1Year:"",
    roiFor3Year:"",
    formSubmittedBy: "",
  };
 
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errors, setErrors] = useState({});

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(formInitialState);
  const [formDataValid, setFormDataValid] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [showClusterOption, setShowClusterOption] = useState(false);
  const [showMcoOption, setShowMcoOption] = useState(false);
  const [showCountryOption, setShowCountryOption] = useState(false);
  const [showLeadPlatformOption, setShowLeadPlatformOption] = useState(false);
  const [showAreaOption, setShowAreaOption] = useState(false);
  const [showSubAreaOption, setShowSubAreaOption] = useState(false);
  const [selectedMCO, setSelectedMCO] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [relatedCountries, setRelatedCountries] = useState([]);
  const [relatedSubArea, setRelatedSubArea] = useState([]);
  const [technologyOption, setTechnologyOption] = useState(false);
  const [indexForMCO, setIndexForMCO] = useState(null);
  const [indexForArea, setIndexForArea] = useState(null);
  const [activeTab, setActiveTab] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);  

  const clusterRef = useRef(null);
  const mcoRef = useRef(null);
  const countryRef = useRef(null);
  const leadPlatformRef = useRef(null);
  const areaRef = useRef(null);
  const subAreaRef = useRef(null);
  const technologyRef = useRef(null);
  const [resRoiYear, setResRoiYear] = useState('ROI For 1 Year');
  const [roiYear, setRoiYear] = useState('ROI For 1 Year');

  const goTo = (link) => {
    // console.log(link);
    router.push(link);
  };

  const closeSuccessModal = () => {
    setShowModal(false);
  };

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const empid = params.get("empTwinId");
  console.log(empid);
  localStorage.setItem("empid", JSON.stringify(empid));

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Check if the current field is empty (including spaces)
    const isEmptyField = e.target.value.trim() === "";
    setErrors({
      [e.target.name]: isEmptyField,
    });
  };
  console.log("errors", errors);
  console.log("errorMsg", errorMsg);

  const handleResRoiYear = (e) => {
    setResRoiYear(e.target.value);
  };
  const handleRoiYear = (e) => {
    setRoiYear(e.target.value);
  };
  console.log('resRoiYear',resRoiYear);

  const checkAuthorization = async () => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    try {
      const { data } = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/roi/checkAuthorization`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
     // console.log("checkAuthorization",data);
      if (data.data.code === 200) {
        console.log("Authorized User", data.data);
      } else if(data.code === 403) {
        setLoading(false);
        console.log("Error in authorization", data);
        props.sessionTimeOutCheck(true);
      }else{
      }
    } catch (error) {
      console.log("Error in Authorization", error);
    }
  };

  const handleContinue = () => {
    // Validate the form fields
    checkAuthorization();
    const requiredFields = [
      "clusterProcess",
      "expectedMcoType",
      "expectedCountry",
      // "leadPlatformProcess",
      // "expectedArea",
      // "expectedSubArea",
      "opportunityName",
      "opportunityDescription",
      // "technology",
      // "botId",
    ];
    let isFormValid = false;

    for (const fieldName of requiredFields) {
      if (!formData[fieldName].trim()) {
        // If the field is empty or contains only spaces
        // alert(`Please enter valid input in the field "${fieldName}".`);
        console.log(`Please enter valid input in the field "${fieldName}".`);
        isFormValid = true;
        break;
      }
    }
    setErrorMsg(isFormValid);
    if (!isFormValid) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleNext = () => {
    // Validate the form fields
    checkAuthorization();
    const requiredFields = [
      "manualHours",
      "annualExecutedProcess",
      "resourceProcess",
      "errorRateProcess",
    ];
    let isFormValid = false;
    for (const fieldName of requiredFields) {
      if (!formData[fieldName]) {
        // If the field is empty or contains only spaces
        // alert(`Please enter valid input in the field "${fieldName}".`);
        console.log(`Please enter valid input in the field "${fieldName}".`);
        isFormValid = true;
        break;
      }
      // if (typeof !formData[fieldName] === 'string') {
      // }
      // else{
        
      // }
    }
    setErrorMsg(isFormValid);
    if (!isFormValid) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
    setFormDataValid(false);
    if(step === 4){
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  console.log('setFormDataValid',formDataValid);
  const handleShowRoi = () => {
    // Validate the form fields
    checkAuthorization();
    const requiredFields = [
      // "costAvoidance",
      // "impactOfOKR",
      "developmentCost",
      "runCostProcess",
    ];
    let isFormValid = false;

    for (const fieldName of requiredFields) {
      if (!formData[fieldName]) {
        // If the field is empty or contains only spaces
        // alert(`Please enter valid input in the field "${fieldName}".`);
        console.log(`Please enter valid input in the field "${fieldName}".`);
        isFormValid = true;
        break;
      }
      // if (typeof !formData[fieldName] === 'string') {
      // }
    }
    setErrorMsg(isFormValid);
    if (!isFormValid) {
      setFormDataValid(true);
      setFormData({
        ...formData,
        manualHours:saving_A,
        annualExecutedProcess:saving_B,
        resourceProcess:saving_C,
        errorRateProcess:saving_D,
        developmentCost:DevlopmentCost,
        runCostProcess:RunCost,
        resRoiMonthsBreakdown: ResBreakEvenInMonths,
        resRoiFor1Year: Math.round(ResROIOneYear),
        resRoiFor3Year: Math.round(ResROIThreeYear),
        roiMonthsBreakdown: RoiBreakEvenInMonths,
        roiFor1Year: Math.round(ROIOneYear),
        roiFor3Year: Math.round(ROIThreeYear),
      });
      setLoading(true);
      if(step === 3){
        setTimeout(() => {
          setLoading(false);
          setStep((prevStep) => prevStep + 1);
        }, 1000);
      }
    }
  }
  const handleProjectDetails = () => {
    setStep(1);
  };
  let activeBtn = step === 1 && styles.activeBtn;
  let activeBtns = step !== 1 && styles.activeBtns;
  let roiformData = props.data;
  let roiOnlyformData = props.data[0].component.content.field_request_demo_form_componen;
  console.log("roiformData", roiformData);
  console.log("roiOnlyformData", roiOnlyformData);
  let roiFormImage = endpoints.drupalIp + props.data[2].component.content.field_background_image
  [0].file_url
  console.log("roiFormImage", roiFormImage);

  let resRoiFormulaImage = endpoints.drupalIp + props.data[2].component.content.field_background_image_mobile[0].file_url;
  let roiFormulaImage = endpoints.drupalIp + props.data[2].component.content.field_background_image_mobile[1].file_url;

  const {
    clusterProcess,
    expectedMcoType,
    expectedCountry,
    leadPlatformProcess,
    expectedArea,
    expectedSubArea,
    opportunityName,
    opportunityDescription,
    technology,
    botId,
    manualHours,
    annualExecutedProcess,
    resourceProcess,
    errorRateProcess,
    costAvoidance,
    impactOfOKR,
    developmentCost,
    runCostProcess,
  } = formData;

  const saving_A = +manualHours;
  const saving_B = +annualExecutedProcess;
  const saving_C = +resourceProcess;
  const saving_D = +errorRateProcess;
  const CostAvoidance = +costAvoidance;
  const DevlopmentCost = +developmentCost;
  const RunCost = +runCostProcess;

  // for AnnualizedSavings For Res and Roi Calculation 
  const resourseSavings = (((30000*saving_A*saving_B*saving_C)*(1+ saving_D/100)) / (2000));
  const resAnnualizedSavings = Math.round(resourseSavings * 100) / 100;
  const roiAnnualizedSavings = Math.round((resourseSavings + CostAvoidance) * 100) / 100;

  // for BreakEvenMonth Calculation 
  const ResBreakEvenInMonths = Math.round((DevlopmentCost * 12 / (resAnnualizedSavings - RunCost))* 100) / 100;
  const RoiBreakEvenInMonths = Math.round((DevlopmentCost * 12 / (roiAnnualizedSavings - RunCost))* 100) / 100;
  
  // For Res ROI And Roi Yearly Calculation
  const resRoiMonths = (resRoiYear == 'ROI For 1 Year') ? 1 : (resRoiYear == 'ROI For 2 Year') ? 2 :3;
  const resROIForYear = (Math.round((((resAnnualizedSavings * resRoiMonths) - DevlopmentCost - (RunCost * resRoiMonths))/ ((RunCost * resRoiMonths) + DevlopmentCost)) * 100)/100)*100

  const roiMonths = (roiYear == 'ROI For 1 Year') ? 1 : (roiYear == 'ROI For 2 Year') ? 2 :3;
  const roiForYear = (Math.round((((roiAnnualizedSavings * roiMonths) - DevlopmentCost - (RunCost * roiMonths))/ ((RunCost * roiMonths) + DevlopmentCost)) * 100)/100)*100;
  
// For Res ROI For 1 and 3 Year Calculation
  const ResROIOneYear = (Math.round(((resAnnualizedSavings - RunCost - DevlopmentCost )/ (RunCost  + DevlopmentCost)) * 100)/100)*100;
  const ResROIThreeYear = (Math.round((((resAnnualizedSavings * 3) - (RunCost * 3) - DevlopmentCost )/ ((RunCost * 3) + DevlopmentCost)) * 100)/100)*100;

// For ROI For 1 and 3 Year Calculation
  const ROIOneYear = (Math.round(((roiAnnualizedSavings - RunCost - DevlopmentCost)/ (RunCost  + DevlopmentCost)) * 100)/100)*100;
  const ROIThreeYear = (Math.round((((roiAnnualizedSavings * 3) - (RunCost * 3) - DevlopmentCost )/ ((RunCost * 3) + DevlopmentCost)) * 100)/100)*100;

  console.log('ResBreakEvenInMonths',ResBreakEvenInMonths);
  console.log('RoiBreakEvenInMonths',RoiBreakEvenInMonths);
  console.log('resourseSavings',resourseSavings);
  console.log('resAnnualizedSavings',resAnnualizedSavings);
  console.log('roiAnnualizedSavings',roiAnnualizedSavings);
  console.log('resROIForYearly',resROIForYear);
  console.log(`ResROIOneYear - ${Math.round(ResROIOneYear)} ResROIThreeYear - ${Math.round(ResROIThreeYear)}`);
  console.log(`ROIOneYear - ${Math.round(ROIOneYear)} ROIThreeYear - ${Math.round(ROIThreeYear)}`);
  
  const handleFormSubmit = (e) => {
    if (formDataValid) {
      const cleanedFormData = {};
      for (const [key, value] of Object.entries(formData)) {
        if (typeof value === 'string') {
          cleanedFormData[key] = value.trim().replace(/\s+/g, ' '); // Trim and remove extra spaces
        } else {
          cleanedFormData[key] = value; // Leave non-string values as they are
        }
      }
      // cleanedFormData.formSubmittedBy = 'satyam.kumar@ens.enterprises';
      cleanedFormData.formSubmittedBy = JSON.parse(localStorage.getItem("auth")).data.email;
      //console.log("Data Submitted Successfully",cleanedFormData);
      addFormData(cleanedFormData);
      // addFormDataWithEmail(cleanedFormData);
      setLoading(true);
      setTimeout(() => {
        setFormData(formInitialState);
        setFormDataValid(false);
        setStep(1);
      }, 2000);
    }else{
      // alert("Please Enter a valid form data");
    }
  };

  const extractExcelData = (e) => {
    if (formDataValid) {
      const cleanedFormData = {};
      for (const [key, value] of Object.entries(formData)) {
        if (typeof value === 'string') {
          cleanedFormData[key] = value.trim().replace(/\s+/g, ' '); // Trim and remove extra spaces
        } else {
          cleanedFormData[key] = value; // Leave non-string values as they are
        }
      }
      cleanedFormData.formSubmittedBy = JSON.parse(localStorage.getItem("auth")).data.email;
      console.log("Data Submitted Successfully");
      cleanedFormData.resRoiFor1Year = `${Math.round(ResROIOneYear)} %`;
      cleanedFormData.resRoiFor3Year = `${Math.round(ResROIThreeYear)} %`;
      cleanedFormData.roiFor1Year = `${Math.round(ROIOneYear)} %`;
      cleanedFormData.roiFor3Year = `${Math.round(ROIThreeYear)} %`;

      //excelData(cleanedFormData);
      checkAuthorizationAndExport(cleanedFormData);

      setLoading(true);
    }else{
      // alert("Please Enter a valid form data");
    }
  };

  // Code for insert Data in database and Send E-mail
  // const addFormDataWithEmail = async (formData) => {
  //   let auth = JSON.parse(localStorage.getItem("auth")).data;
  //   try {
  //     const { data } = await axios({
  //       method: "POST",
  //       url: `${endpoints.baseUrl}/roi/sendformdata`,
  //       headers: {
  //         Authorization: `${auth.accessToken}|${auth.email}`,
  //       },
  //       data: formData,
  //     });
  //     if (data.code === 200) {
  //       setTimeout(() => {
  //         setLoading(false);
  //         setShowModal(true);
  //       }, 2000);
  //       console.log("Successfully E-mail Sent & Data Added Into Database:", data);
  //     } else {
  //       setLoading(true);
  //       console.log("Error in sending data in database & Email Send:", data);
  //     }
  //   } catch (error) {
  //     console.log("Error in sending emai & data:", error);
  //   }
  // };
  
  // Code for inserting data into database only 
  const addFormData = async (formData) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    try {
      const { data } = await axios({
        method: "POST",
        url: `${endpoints.baseUrl}/roi/getformdata`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: formData,
      });
      if (data.code === 200) {
        setTimeout(() => {
          setLoading(false);
          setShowModal(true);
        }, 2000);
        console.log("Data successfully added into database:", data);
      } else {
        console.log("Error in sending data in database:", data);
        setLoading(false);
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log("Error in sending data:", error);
    }
  };
  const excelData = async (formData) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    try {
      const response = await axios({
        method: "POST",
        url: `${endpoints.baseUrl}/roi/exportInExcel`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: formData,
        responseType: 'blob', // Set the response type to 'blob' to receive binary data
      });
      
      if (response.status === 200) {
        // Create a blob from the binary data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);
  
        // Create an anchor element to trigger the download
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'Roi Form Data.xlsx';
  
        // Trigger a click event on the anchor element
        document.body.appendChild(a);
        a.click();
  
        // Clean up by revoking the blob URL
        setTimeout(() => {
          setLoading(false);
          window.URL.revokeObjectURL(url);
        }, 1000);
        console.log("Data successfully Exported in Excel");
      } else {
        console.log("Error in API response:", response);
      }
    } catch (error) {
      console.log("Error in Exported Data:", error);
    }
  };
  
  const checkAuthorizationAndExport = async (formData) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    try {
      const { data } = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/roi/checkAuthorization`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        }
      });
     // console.log("checkAuthorization", data);
      if (data.data.code === 200) {
        // Authorization is successful, proceed to export Excel data
        excelData(formData)
      } else if (data.code === 403) {
        setLoading(false);
        props.sessionTimeOutCheck(true);
      } else {
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log("Error in Authorization", error);
    }
  };

  console.log("formDataValue", formData);
  const handleOptionChange = (option, name, index, additionalStateChanges = {}) => {
    setSelectedOption(option);
    setShowMcoOption(false);
    setShowClusterOption(false);
    setShowCountryOption(false);
    setShowLeadPlatformOption(false);
    setShowAreaOption(false);
    setShowSubAreaOption(false);
    setTechnologyOption(false);
  
    const updatedFormData = {
      ...formData,
      [name]: option,
      ...additionalStateChanges, // Any additional state changes specific to the function
    };
  
    setFormData(updatedFormData);
    console.log('optionName', option, name, index);
  };
  
  const onClusterChange = (option, name, index) => {
    setIndexForMCO(index);
    handleOptionChange(option, name, index, {
      expectedMcoType: '',
      expectedCountry: '',
    });
  };
  
  const onLeadPlatformChange = (option, name, index) => {
    setIndexForArea(index);
    handleOptionChange(option, name, index, {
      expectedArea: '',
      expectedSubArea: '',
    });
  };
  
  const onMCOChange = (option, name) => {
    handleOptionChange(option, name, null, {
      expectedCountry: '',
    });
    setSelectedMCO(option);
  };
  
  const onAreaChange = (option, name) => {
    handleOptionChange(option, name, null, {
      expectedSubArea: '',
    });
    setSelectedArea(option);
  };
  
  const onCountryChange = (option, name) => {
    handleOptionChange(option, name);
  };
  
  const onSubAreaChange = (option, name) => {
    handleOptionChange(option, name);
  };
  const handleOptionSelect = (option, name) => {
    handleOptionChange(option, name);
  };
  

  useEffect(() => {
    function handleClickOutside(event) {
      if (clusterRef.current && !clusterRef.current.contains(event.target)) {
        setShowClusterOption(false); 
      }
      if (mcoRef.current && !mcoRef.current.contains(event.target)) {
        setShowMcoOption(false); 
      }
      if (countryRef.current && !countryRef.current.contains(event.target)) {
        setShowCountryOption(false); 
      }
      if (leadPlatformRef.current && !leadPlatformRef.current.contains(event.target)) {
        setShowLeadPlatformOption(false); 
      }
      if (areaRef.current && !areaRef.current.contains(event.target)) {
        setShowAreaOption(false); 
      }
      if (subAreaRef.current && !subAreaRef.current.contains(event.target)) {
        setShowSubAreaOption(false); 
      }
      if (technologyRef.current && !technologyRef.current.contains(event.target)) {
        setTechnologyOption(false); 
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function getRelatedCountries(selectedMCO) {
    const mcoGroup = clusterFormData[2].field_dropdown_option_component.find(
      (group) => group.field_title === selectedMCO
    );
    if (mcoGroup) {
      return mcoGroup.field_options;
    }
    return [];
  }
  function getRelatedSubArea(selectedArea) {
    const mcoGroup = leadplatFormData[2].field_dropdown_option_component.find(
      (group) => group.field_title === selectedArea
    );
    if (mcoGroup) {
      return mcoGroup.field_options;
    }
    return [];
  }
  
  useEffect(() => {
    setRelatedCountries(getRelatedCountries(selectedMCO));
    setRelatedSubArea(getRelatedSubArea(selectedArea));
  }, [selectedMCO,selectedArea]);

  const resRoiChartData = [
		{name:"1 Year", x:0, y:Math.round(ResROIOneYear)},
		{name:"3 Year", x:0, y:Math.round(ResROIThreeYear)}
	];
  const roiChartData = [
		{name:"1 Year", x:0, y:Math.round(ROIOneYear)},
		{name:"3 Year", x:0, y:Math.round(ROIThreeYear)}
	];
  const headerStyle = {
    backgroundImage: `linear-gradient(rgba(0, 94, 239, 0.9), rgba(0, 94, 239, 0.9)),url(${roiFormImage})`,
    backgroundRepeat: 'repeat',
    width: '100%',
    backgroundSize: '30px',
  };

  const handleMouseOver = () => {
    setIsModalVisible(true);
  };

  const handleMouseOut = () => {
    setIsModalVisible(false);
  };

  return (
    <div className={`${styles.landingContainer}`}>
      <div className={`${styles.roiHeader} container-fluid`} style={headerStyle}>
              <div className="row">
                <div className="col-md-12">
                  <div className={`${styles.roiHeaderText}`}>
                  <span className={`${styles.firstText}`}>R</span>eturn <span className={`${styles.firstText}`}>O</span>n <span className={`${styles.firstText}`}>I</span>nvestment</div>
                </div>
              </div>
          </div>
      <div className={`${styles.roiFormContainer} container-fluid`}> 

        {(step === 4) ? (
          <div className={`${styles.roiFormRow} ${styles.roiCalculationRow} row`}>
          <div className={`${styles.roiFormulaContainer} col-md-12`}>
            <div className={`${styles.tabContainer} container`}>
              <div className={`${styles.roiCalculation} ${styles.roiTabRow} row`}>
                <div className={`${styles.roiBothTabs} ${styles.resourceRoiWrapper} col-md-6`}>
                    <div className={`${styles.btnTab} ${activeTab ? styles.activeBtn : styles.resBtn }`} onClick={() => setActiveTab(true)}>Resource ROI 
                     
                    </div>
                  </div>
                <div className={`${styles.roiBothTabs} ${styles.resourceRoiWrapper} col-md-6`}>
                    <div className={`${styles.btnTab} ${!activeTab ? styles.activeBtn : styles.roiBtn }`} onClick={() => setActiveTab(false)}>ROI 
                      
                  </div>
                </div>
              </div>
            </div>
            {activeTab && (
            <div className={`${styles.roiCalculation} ${styles.resRoiRowWrapper} row`}>
              <div className={`${styles.calculationWrapper} ${styles.resourceRoiWrapper} col-md-6`}>
                <div className={styles.heading}>Resource ROI 
                  <div className={`${styles.tooltipModal} ${styles.overlayModalContainer}`} >
                  <span onMouseOver={handleMouseOver}>
                     <Icons name="information" className={`${styles.information}`}  /> 
                  </span>
                  </div>
                  {resRoiFormulaImage ? <>
                      <div className={`${styles.overlayModal} ${isModalVisible ? styles.modalOpen : ''}`}>
                      <div class={styles.popup}>
                      <div class={styles.close} href="#" onClick={handleMouseOut}>×</div>
                          {/*<img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/resRoiFormula.png" alt="Resource Roi Calculation" />*/}
                          <img src={resRoiFormulaImage} alt="Resource ROI Formula" />
                        </div> 
                      </div>
                      </> : null}
                </div>
                <div className={`${styles.allCalculation} ${styles.monthsBreakdown}`}>
                  <div className={styles.result}>
                  <span className={styles.text}><span className={styles.topText}>Months</span> <sub className={styles.bottomText}>Breakeven</sub></span> = <span className={styles.totalMonthBreak}> {ResBreakEvenInMonths}</span>
                  </div>
                </div>
                <div className={`${styles.allCalculation} ${styles.RoiBreakdown}`}>
                <div className={styles.formGroup}>
                    <select
                      className={`${styles.selectGroup} ${styles.dropDownFields}`}
                      onChange={handleResRoiYear}
                      name="resRoiYear"
                      id="resRoiYear"
                      value={resRoiYear}>
                      <option defaultValue>
                      ROI For 1 Year
                      </option>
                      <option defaultValue>
                      ROI For 3 Year
                      </option>
                    </select>
                  </div>
                  <div className={styles.forOne}>
                    <span className={styles.topText}>{resRoiYear}</span> = <span className={styles.yearlyTotal}> {Math.round(resROIForYear)} %</span>
                  </div>
                </div>
              </div>
              <div className={`${styles.calculationWrapper} ${styles.resourceRoiWrapper} col-md-6`}>
               <AreaChart width={350} height={220} data={resRoiChartData} margin={{ top: 25, right: 10, bottom: 0, left: 0 }}>
                <CartesianGrid stroke="#ccc" strokeDasharray="3.5"/>
                <XAxis dataKey="name" fontSize="11px" stroke="#000"/>
                <YAxis fontSize="11px" stroke="#000"/>
                <Tooltip />
                <Area dataKey="x" 
                  stroke="#005dee" fill="#005dee8f" />
                <Area dataKey="y" 
                  stroke="#005dee" fill="#005dee8f" />
              </AreaChart>
              </div>
            </div>
            )}
            {!activeTab && (
            <div className={`${styles.roiCalculation} ${styles.roiRowWrapper} row`}>
            <div className={`${styles.calculationWrapper} ${styles.RoiWrapper} col-md-6`}>
              <div className={styles.heading}>ROI 
                  <div className={`${styles.tooltipModal} ${styles.overlayModalContainer}`} >
                  <span onMouseOver={handleMouseOver}>
                     <Icons name="information" className={`${styles.information}`}  /> 
                  </span>
                  </div>
                  {roiFormulaImage ? <>
                      <div className={`${styles.overlayModal} ${isModalVisible ? styles.modalOpen : ''}`}>
                      <div class={styles.popup}>
                      <div class={styles.close} href="#" onClick={handleMouseOut}>×</div>
                          {/*<img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/roiFormula.png" alt="Roi Calculation" />*/}
                          <img src={roiFormulaImage} alt="ROI Formula" />
                        </div> 
                      </div>
                      </> : null}
                </div>
              <div className={`${styles.allCalculation} ${styles.monthsBreakdown}`}>
                <div className={styles.result}>
                <span className={styles.text}><span className={styles.topText}>Months</span> <sub className={styles.bottomText}>Breakeven</sub></span> = 
                <span className={styles.totalMonthBreak}> {RoiBreakEvenInMonths}</span>
                </div>
              </div>
              <div className={`${styles.allCalculation} ${styles.RoiBreakdown}`}>
              <div className={styles.formGroup}>
                <select
                  className={`${styles.selectGroup} ${styles.dropDownFields}`}
                  onChange={handleRoiYear}
                  name="roiYear"
                  id="roiYear"
                  value={roiYear}>
                  <option defaultValue>
                  ROI For 1 Year
                  </option>
                  <option defaultValue>
                  ROI For 3 Year
                  </option>
                </select>
              </div>
              <div className={styles.forOne}>
                <span className={styles.topText}>{roiYear}</span> = <span className={styles.yearlyTotal}> {Math.round(roiForYear)} %</span>
              </div>
              </div>
            </div>
            <div className={`${styles.calculationWrapper} ${styles.resourceRoiWrapper} col-md-6`}>
            <AreaChart width={350} height={180} data={roiChartData} margin={{ top: 25, right: 10, bottom: 0, left: 0 }}>
                <CartesianGrid strokeDasharray="3.5"/>
                <XAxis dataKey="name" fontSize="11px"/>
                <YAxis fontSize="11px"/>
                <Tooltip />
                <Area dataKey="x" 
                  stroke="#005dee" fill="#005dee8f" />
                <Area dataKey="y" 
                  stroke="#005dee" fill="#005dee8f" />
            </AreaChart>
            </div>
            </div>
            )}
            <div className={`${styles.roiCalculation} row`}>
            <div className={`${styles.actionBtnWrapper} col-md-12`}>
            <div className={`${styles.actionBtn} container`}>
              <button className={`${styles.btns} ${styles.backBtn}`}
                    onClick={handleBack}
                  >
                    <span className={`${styles.backArrowIcon}`}>
                      <Icons name="leftArrow" className={styles.leftArrow} />
                    </span>
                    <span className={`${styles.text}`}>Back</span>
              </button>
              <button className={`${styles.btns} ${styles.extractDataBtn}`} onClick={extractExcelData}>
                    <span className={`${styles.text}`}>Extract Data</span>
                    <span className={`${styles.arrowIcon}`}>
                      <Icons
                        name="rightArrow"
                        className={styles.rightArrow}
                      />
                    </span>
              </button>
              <button className={`${styles.btns} ${styles.submitBtn}`} onClick={handleFormSubmit}>
                    <span className={`${styles.text}`}>Submit</span>
                    <span className={`${styles.arrowIcon}`}>
                      <Icons
                        name="rightArrow"
                        className={styles.rightArrow}
                      />
                    </span>
              </button>
                </div>
            </div>
            </div>
          </div>

      </div>
        ): (<>
          {/*<div className={`${styles.roiBannerHeader} container-fluid`}>
              <div className="row">
                <div className={`${styles.bannerColumn} col-md-12`}>
                  <img className={styles.roi_Image} src={roiFormImage} 
                  alt="Return on Investment"/>
                   <h2 className={`${styles.roiHeading}`}>
                    {_get(roiOnlyformData[0], "field_label")}
                  </h2> 
                </div>
              </div>
            </div>*/}

            <div className={`${styles.roiFormRow} row`}>

          <div className={`${styles.roiFormColumn} col-md-12`}>
          {/*  <div className={`${styles.roiHeader} container-fluid`}>
              <div className="row">
                 <div className="col-md-12">
                   <img className={styles.roi_Image} src={roiFormImage} 
                  alt="Return on Investment"/>
                   <h2 className={`${styles.roiHeading}`}>
                    {_get(roiOnlyformData[0], "field_label")}
                  </h2>
	          <h2 className={`${styles.roiHeaderText}`}>
                  <span className={`${styles.firstText}`}>R</span>eturn <span className={`${styles.firstText}`}>O</span>n <span className={`${styles.firstText}`}>I</span>nvestment</h2>
                 </div>
                <div className="col-md-12">
                  <div className={`${styles.roiBtns}`}>
                    <button
                      className={`${styles.projectDetails} ${styles.btns} ${activeBtn}`}
                      onClick={handleProjectDetails}
                    >
                      {_get(roiOnlyformData[0], "field_options[0]", "")}
                    </button>
                    <button
                      className={`${styles.currentProcess} ${styles.btns} ${activeBtns}`}
                    >
                      {_get(roiOnlyformData[0], "field_options[1]", "")}
                    </button>
                  </div>
                </div>
              </div>
            </div>*/}
            {step === 1 && (
              <>
                <div className={`${styles.projectDetailsField} ${styles.projectDetailsColumn} container-fluid `}>
                  <div className={`${styles.projectClusterRow} ${styles.projectClusterLeft} row`}>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                            Cluster
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (clusterProcess == "" &&
                                clusterProcess.length == 0) ||
                              errors.clusterProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div>
                        <div className={`${`${styles.selectGroup} ${styles.dropDownFields}`} ${styles.dropDownFields}`} ref={clusterRef}>
                      {/*  {errorMsg ? (
                              (clusterProcess == "" &&
                                clusterProcess.length == 0) ||
                              errors.clusterProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null} */}

                          <div
                          className={`${styles.selectedOption} ${selectedOption}`}
                          onClick={() => setShowClusterOption((prev) => !prev)}
                          >
                         <span className={`${styles.leftSelect} ${(clusterProcess == "" && clusterProcess.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {clusterProcess || `Select Cluster`}</span>
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span>
                          </div>
                          {showClusterOption && (
                          <div className={styles.optionsContainer}>
                            <div className={`${styles.option}`}
                            onClick={() => {onClusterChange("","clusterProcess")}}>
                            {_get(clusterFormData[0], "field_input", "")}
                            </div>
                            {_get(clusterFormData[0], "field_options", []).map((option, index) => (
                            <div key={index} className={styles.option}
                              onClick={() => onClusterChange(option,"clusterProcess",index)}>
                              {option}
                            </div>
                            ))}
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                            MCO
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (expectedMcoType == "" &&
                                expectedMcoType.length == 0) ||
                              errors.expectedMcoType ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div>
                        <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={mcoRef}>
                        {/*{errorMsg ? (
                              (expectedMcoType == "" &&
                                expectedMcoType.length == 0) ||
                              errors.expectedMcoType ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}

                          <div
                          className={`${styles.selectedOption} ${selectedOption}`}
                          onClick={() => {setShowMcoOption((prev) => !prev);
                            }}
                          >
                        <span className={`${styles.leftSelect} ${(expectedMcoType == "" && expectedMcoType.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {expectedMcoType || "Select MCO"}</span>
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span>
                          </div>
                          {showMcoOption && (
                          <div className={styles.optionsContainer}>
                            <div className={`${styles.option}`}
                            onClick={() => {onMCOChange("","expectedMcoType")}}>
                            {_get(clusterFormData[1], "field_input", "")}
                            </div>
                            {_get(clusterFormData[1].field_dropdown_option_component[indexForMCO], "field_options", []).map((option, index) => (
                            <div key={index} className={styles.option}
                              onClick={() => onMCOChange(option,"expectedMcoType",index)}>
                              {option}
                            </div>
                            ))}
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                            Country
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (expectedCountry == "" &&
                                expectedCountry.length == 0) ||
                              errors.expectedCountry ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div>
                        <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={countryRef}>
                        {/*{errorMsg ? (
                              (expectedCountry == "" &&
                                expectedCountry.length == 0) ||
                              errors.expectedCountry ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}

                          <div
                          className={`${styles.selectedOption} ${selectedOption}`}
                          onClick={() => setShowCountryOption((prev) => !prev)}
                          >
                        <span className={`${styles.leftSelect} ${(expectedCountry == "" && expectedCountry.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {expectedCountry || "Select Country"}</span>
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span>
                          </div>
                          {showCountryOption && (
                          <div className={styles.optionsContainer}>
                            <div className={`${styles.option}`}
                            onClick={() => {onCountryChange("","expectedCountry")}}>
                            {_get(clusterFormData[2], "field_input", "")}
                            </div>
                            {relatedCountries.map((country, index) => (
                              <div key={index} className={styles.option}
                                onClick={() => onCountryChange(country, "expectedCountry", index)}>{country}</div>
                            ))}
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                            Lead Platform / Function
                            {/* <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (leadPlatformProcess == "" &&
                                leadPlatformProcess.length == 0) ||
                              errors.leadPlatformProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null} */}
                          </label>
                        </div>
                        <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={leadPlatformRef}>
                          <div
                          className={`${styles.selectedOption} ${selectedOption}`}
                          onClick={() => setShowLeadPlatformOption((prev) => !prev)}
                          >
                         <span className={`${styles.leftSelect} ${(leadPlatformProcess == "" && leadPlatformProcess.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {leadPlatformProcess || "Select lead platform"}</span>
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span>
                          </div>
                          {showLeadPlatformOption && (
                          <div className={styles.optionsContainer}>
                            <div className={`${styles.option}`}
                            onClick={() => {onLeadPlatformChange("","leadPlatformProcess")}}>
                            {_get(leadplatFormData[0], "field_input", "")}
                            </div>
                            {_get(leadplatFormData[0], "field_options", []).map((option, index) => (
                            <div key={index} className={styles.option}
                              onClick={() => onLeadPlatformChange(option,"leadPlatformProcess",index)}>
                              {option}
                            </div>
                            ))}
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                          <div className={styles.formGroup}>
                            <div className={styles.formLabel}>
                              <label className={styles.mainLabel}>
                                {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                                Area
                                {/* <sup className={styles.mandatoryField}>*</sup>
                                {errorMsg ? (
                                  (expectedArea == "" &&
                                    expectedArea.length == 0) ||
                                  errors.expectedArea ? (
                                    <span className={styles.errorMessage}>
                                      {_get(
                                        roiOnlyformData[1],
                                        "field_message_ip_error_message",
                                        []
                                      )}
                                    </span>
                                  ) : null
                                ) : null} */}
                              </label>
                            </div>
                            <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={areaRef}>
                              <div
                              className={`${styles.selectedOption} ${selectedOption}`}
                              onClick={() => {setShowAreaOption((prev) => !prev);
                                }}
                              >
                            <span className={`${styles.leftSelect} ${(expectedArea == "" && expectedArea.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {expectedArea || "Select Area"}</span>
                              <span className={styles.right}>
                                <Icons name="chevron" className={styles.chevron} />
                              </span>
                              </div>
                              {showAreaOption && (
                              <div className={styles.optionsContainer}>
                                <div className={`${styles.option}`}
                                onClick={() => {onAreaChange("","expectedArea")}}>
                                {_get(leadplatFormData[1], "field_input", "")}
                                </div>
                                {_get(leadplatFormData[1].field_dropdown_option_component[indexForArea], "field_options", []).map((option, index) => (
                                <div key={index} className={styles.option}
                                  onClick={() => onAreaChange(option,"expectedArea",index)}>
                                  {option}
                                </div>
                                ))}
                              </div>
                              )}
                            </div>
                          </div>
                    </div>
                    </div>
                    <div className={`${styles.projectClusterRow} ${styles.projectClusterRight} row`}>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                          <div className={styles.formGroup}>
                            <div className={styles.formLabel}>
                              <label className={styles.mainLabel}>
                                {/* {_get(roiOnlyformData[1], "field_label", "")} */}
                                Sub Area
                                {/* <sup className={styles.mandatoryField}>*</sup>
                                {errorMsg ? (
                                  (expectedSubArea == "" &&
                                    expectedSubArea.length == 0) ||
                                  errors.expectedSubArea ? (
                                    <span className={styles.errorMessage}>
                                      {_get(
                                        roiOnlyformData[1],
                                        "field_message_ip_error_message",
                                        []
                                      )}
                                    </span>
                                  ) : null
                                ) : null} */}
                              </label>
                            </div>
                            <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={subAreaRef}>
                              <div
                              className={`${styles.selectedOption} ${selectedOption}`}
                              onClick={() => setShowSubAreaOption((prev) => !prev)}
                              >
                            <span className={`${styles.leftSelect} ${(expectedSubArea == "" && expectedSubArea.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {expectedSubArea || "Select Sub Area"}</span>
                              <span className={styles.right}>
                                <Icons name="chevron" className={styles.chevron} />
                              </span>
                              </div>
                              {showSubAreaOption && (
                              <div className={styles.optionsContainer}>
                                <div className={`${styles.option}`}
                                onClick={() => {onSubAreaChange("","expectedSubArea")}}>
                                {_get(leadplatFormData[2], "field_input", "")}
                                </div>
                                {relatedSubArea.map((country, index) => (
                                  <div key={index} className={styles.option}
                                    onClick={() => onSubAreaChange(country, "expectedSubArea", index)}>{country}</div>
                                ))}
                              </div>
                              )}
                            </div>
                          </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[5], "field_label", "")}
                            {/* <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (technology == "" &&
                                technology.length == 0) ||
                              errors.technology ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null} */}
                          </label>
                        </div>
                        <div className={`${styles.selectGroup} ${styles.dropDownFields}`} ref={technologyRef}>
                          <div
                          className={`${styles.selectedOption} ${selectedOption}`}
                          onClick={() => setTechnologyOption((prev) => !prev)}
                          >
                         <span className={`${styles.leftSelect} ${(technology == "" && technology.length == 0) ? styles.leftSelectBlur:styles.leftSelectText}`}> {technology || "Select technology"}</span>
                          <span className={styles.right}>
                            <Icons name="chevron" className={styles.chevron} />
                          </span>
                          </div>
                          {technologyOption && (
                          <div className={styles.optionsContainer}>
                            <div className={`${styles.option}`}
                            onClick={() => handleOptionSelect("","technology")}>
                            {_get(technologyData[0], "field_input", "")}
                            </div>
                            {_get(technologyData[0], "field_options", []).map((option, index) => (
                            <div key={index} className={styles.option}
                              onClick={() => handleOptionSelect(option,"technology")}>
                              {option}
                            </div>
                            ))}
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[3], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (opportunityName == "" && opportunityName.length == 0) ||
                              errors.opportunityName ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                         {/*   {errorMsg ? (
                              (opportunityName == "" && opportunityName.length == 0) ||
                              errors.opportunityName ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null} */}
                        <input
                          type="text"
                          className={`${styles.inputtext} ${errorMsg ? ((opportunityName == "" && opportunityName.length == 0) || errors.opportunityName ? styles.emptyField:styles.someTextField):null}`}
                          name="opportunityName"
                          id="opportunityName"
                          onChange={handleFieldChange}
                          value={opportunityName}
                          placeholder={`${_get(roiOnlyformData[3], "field_label", "")}`}
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[4], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (opportunityDescription == "" &&
                                opportunityDescription.length == 0) ||
                              errors.opportunityDescription ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div>
                        {/*{errorMsg ? (
                              (opportunityDescription == "" &&
                                opportunityDescription.length == 0) ||
                              errors.opportunityDescription ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                        <input
                          type="text"
                          className={`${styles.inputtext} ${errorMsg ? ((opportunityDescription == "" && opportunityDescription.length == 0) || errors.opportunityDescription ? styles.emptyField:styles.someTextField):null}`}
                          name="opportunityDescription"
                          id="opportunityDescription"
                          onChange={handleFieldChange}
                          value={opportunityDescription}
                          placeholder={`${_get(roiOnlyformData[4], "field_label", "")}`}
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                        <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[6], "field_label", "")}
                            {/* <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (botId == "" &&
                                botId.length == 0) ||
                              errors.botId ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null} */}
                          </label>
                        </div>
                        <input
                          type="text"
                          className={styles.inputtext}
                          name="botId"
                          id="botId"
                          onChange={handleFieldChange}
                          value={botId}
                          placeholder="Enter Bot ID"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${styles.actionBtn} ${styles.continueBtn} container`}>
                  <button
                    className={`${styles.btns}`}
                    onClick={handleContinue}
                  >
                    <span className={`${styles.text}`}>Continue</span>
                    <span className={`${styles.arrowIcon}`}>
                      <Icons
                        name="rightArrow"
                        className={styles.rightArrow}
                      ></Icons>
                    </span>
                  </button>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className={`${styles.projectDetailsField} ${styles.currentProcessFields} container`}>
                  <div className={`${styles.projectDetailsRow} row`}>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[7], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (manualHours == "" &&
                                manualHours.length == 0) ||
                              errors.manualHours ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (manualHours == "" &&
                                manualHours.length == 0) ||
                              errors.manualHours ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                        <input
                          type="number"
                          className={styles.inputtext}
                          name="manualHours"
                          id="manualHours"
                          onChange={handleFieldChange}
                          value={manualHours}
                          min="0" 
                          placeholder="Enter the number of hours"
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[8], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (annualExecutedProcess == "" &&
                                annualExecutedProcess.length == 0) ||
                              errors.annualExecutedProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (annualExecutedProcess == "" &&
                                annualExecutedProcess.length == 0) ||
                              errors.annualExecutedProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                        <input
                          type="number"
                          className={styles.inputtext}
                          name="annualExecutedProcess"
                          id="annualExecutedProcess"
                          onChange={handleFieldChange}
                          value={annualExecutedProcess}
                          min="0"
                          placeholder="Enter the annual execution frequency"
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[9], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (resourceProcess == "" &&
                                resourceProcess.length == 0) ||
                              errors.resourceProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (resourceProcess == "" &&
                                resourceProcess.length == 0) ||
                              errors.resourceProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}

                        <input
                          type="number"
                          className={styles.inputtext}
                          name="resourceProcess"
                          id="resourceProcess"
                          onChange={handleFieldChange}
                          value={resourceProcess}
                          min="0"
                          placeholder="Enter the number of resources"
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[10], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (errorRateProcess == "" &&
                                errorRateProcess.length == 0) ||
                              errors.errorRateProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (errorRateProcess == "" &&
                                errorRateProcess.length == 0) ||
                              errors.errorRateProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}

                        <input
                          type="number"
                          className={styles.inputtext}
                          name="errorRateProcess"
                          id="errorRateProcess"
                          onChange={handleFieldChange}
                          value={errorRateProcess}
                          min="0"
                          max="0.99"
                          step="0.01"
                          placeholder="Enter the percentage error rate"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${styles.btnWrapper}`}>
                  <div className={`${styles.actionBtn}`}>
                    <button
                      className={`${styles.btns} ${styles.backBtn} ${styles.FirstBackBtn}`}
                      onClick={handleBack}
                    >
                      <span className={`${styles.backArrowIcon}`}>
                        <Icons name="leftArrow" className={styles.leftArrow} />
                      </span>
                      <span className={`${styles.text}`}>Back</span>
                    </button>
                  </div>
                  <div className={`${styles.actionBtn}`}>
                    <button
                      className={`${styles.btns} ${styles.nextBtn}`}
                      onClick={handleNext}
                    >
                      <span>Next</span>
                      <span className={`${styles.arrowIcon}`}>
                        <Icons
                          name="rightArrow"
                          className={styles.rightArrow}
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </>
            )}

            {step === 3 && (
              <>
                <div className={`${styles.projectDetailsField} ${styles.currentProcessField2} container`}>
                  <div className={`${styles.projectDetailsRow} row`}>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[11], "field_label", "")}
                           {/* <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (costAvoidance == "" &&
                                costAvoidance.length == 0) ||
                              errors.costAvoidance ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                          </label>
                        </div>
                        <input
                          type="number"
                          className={styles.inputtext}
                          name="costAvoidance"
                          id="costAvoidance"
                          onChange={handleFieldChange}
                          value={costAvoidance}
                          min='0'
                          placeholder="Enter cost avoidance"
                        />
		       {/* <div className={styles.inputContainer} id={(costAvoidance == "" && costAvoidance.length == 0) || errors.costAvoidance ? null: styles.InputContainerChange}  style={{"opacity":"1"}}>
                        <input
                          type="number"
                          className={`${styles.inputtext}`}
                          name="costAvoidance"
                          id="costAvoidance"
                          onChange={handleFieldChange}
                          value={costAvoidance}
                          min='0'
                        />
                        <label id={(costAvoidance == "" && costAvoidance.length == 0) || errors.costAvoidance ? null: styles.inputLabelChange} className={`${styles.inputLabel}`}>{_get(roiOnlyformData[11], "field_label", "")} *</label>
                        </div>*/}
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[12], "field_label", "")}
                           {/* <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (impactOfOKR == "" &&
                                impactOfOKR.length == 0) ||
                              errors.impactOfOKR ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                          </label>
                        </div> 
                        <input
                          type="text"
                          className={styles.inputtext}
                          name="impactOfOKR"
                          id="impactOfOKR"
                          onChange={handleFieldChange}
                          value={impactOfOKR}
                          placeholder="Enter impact of OKR's"
                        />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[13], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (developmentCost == "" &&
                                developmentCost.length == 0) ||
                              errors.developmentCost ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (developmentCost == "" &&
                                developmentCost.length == 0) ||
                              errors.developmentCost ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                        <input
                          type="number"
                          className={styles.inputtext}
                          name="developmentCost"
                          id="developmentCost"
                          onChange={handleFieldChange}
                          value={developmentCost}
                          min="0"
                          placeholder="Enter development cost"
                       />
                      </div>
                    </div>
                    <div className={`${styles.projectFiledColumn} col-md-12`}>
                      <div className={styles.formGroup}>
                         <div className={styles.formLabel}>
                          <label className={styles.mainLabel}>
                            {_get(roiOnlyformData[14], "field_label", "")}
                            <sup className={styles.mandatoryField}>*</sup>
                            {errorMsg ? (
                              (runCostProcess == "" &&
                                runCostProcess.length == 0) ||
                              errors.runCostProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}
                          </label>
                        </div> 
                        {/*{errorMsg ? (
                              (runCostProcess == "" &&
                                runCostProcess.length == 0) ||
                              errors.runCostProcess ? (
                                <span className={styles.errorMessage}>
                                  {_get(
                                    roiOnlyformData[1],
                                    "field_message_ip_error_message",
                                    []
                                  )}
                                </span>
                              ) : null
                            ) : null}*/}
                        <input
                          type="number"
                          className={styles.inputtext}
                          name="runCostProcess"
                          id="runCostProcess"
                          onChange={handleFieldChange}
                          value={runCostProcess}
                          min="0"
                          placeholder="Enter the annual run cost"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${styles.btnWrapper}`}>
                  <div className={`${styles.actionBtn}`}>
                    <button
                      className={`${styles.btns} ${styles.backBtn} ${styles.secondBackBtn}`}
                      onClick={handleBack}
                    >
                      <span className={`${styles.backArrowIcon}`}>
                        <Icons name="leftArrow" className={styles.leftArrow} />
                      </span>
                      <span className={`${styles.text}`}>Back</span>
                    </button>
                  </div>
                  <div className={`${styles.actionBtn}`}>
                    <button className={`${styles.btns} ${styles.showRoiBtn}`} onClick={handleShowRoi}>
                      <span className={`${styles.text}`}>Show ROI</span>
                      <span className={`${styles.arrowIcon}`}>
                        <Icons
                          name="rightArrow"
                          className={styles.rightArrow}
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        </>
          
        )}
      </div>
      {loading && (
        <>
          <div className={styles.editModalContainer}>
            <Loaders />
          </div>
        </>
      )}
      {showModal && (
        <RoiModal
          setSuccessModal={true}
          name="roiForm"
          title="ROI Form"
          message="message"
          roiFormModal="closeBtn"
          closeModal={closeSuccessModal}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);


